import { render, staticRenderFns } from "./AffiliateBasicInfoForm.vue?vue&type=template&id=06cfcbb2&"
import script from "./AffiliateBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./AffiliateBasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AffiliateBasicInfoForm.vue"
export default component.exports